<template>
  <div class="stripe-wrapper">
    <label class="h6 mb-1">{{ cardLabelText }}</label>
    <div ref="card" class="form-control mb-2" />
    <p v-if="error" class="error mb-3">{{ error }}</p>
    <div v-if="!reachedMinimumAmount" class="text-danger font-weight-bold text-small mb-2">
      {{ hint }} {{ minimumAmount }}.
    </div>
    <div class="wrapper">
      <button
        :disabled="!payButtonEnabled"
        @click="pay"
        class="btn btn-lg btn-primary"
        type="button"
      >
        {{ buttonText }}
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CheckoutPaymentsStripeCreditCards",
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    cardLabelText: {
      type: String,
      required: true,
    },
    fetchPaymentIntentUrl: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: true,
    },
    postPaymentIntentUrl: {
      type: String,
      required: true,
    },
    reachedMinimumAmount: {
      type: Boolean,
      required: true,
    },
    minimumAmount: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: "",
      complete: false,
      payButtonDisabled: false,
      stripeElement: null,
      stripeOptions: {
        hidePostalCode: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      Stripe: "checkoutPayment/globalStripe",
      stripeCardStyle: "checkoutPayment/stripeCardStyle",
    }),
    payButtonEnabled() {
      return !this.payButtonDisabled && this.reachedMinimumAmount;
    },
  },
  watch: {
    Stripe: {
      immediate: true,
      handler() {
        this.initializeCard();
      },
    },
  },
  mounted() {
    this.initializeCard();
  },
  methods: {
    initializeCard() {
      if (this.Stripe.elements !== undefined) {
        this.$nextTick()
          .then(() => {
            this.stripeElement = this.Stripe.elements().create("card", {
              style: this.stripeCardStyle,
              ...this.stripeOptions,
            });
            this.stripeElement.mount(this.$refs.card);
          })
          .catch(() => {});
      }
    },
    cardChangeHandler(event) {
      this.error = "";
      this.complete = event.complete;
      this.payButtonDisabled = !event.complete && !event.empty;
      this.error = event.error ? event.error.message : "";
    },
    async pay() {
      this.payButtonDisabled = true;
      const response = await this.axios.post(this.fetchPaymentIntentUrl);
      const stripeResponse = await this.Stripe.handleCardPayment(
        response.data.payment_intent_secret,
        this.stripeElement
      );
      if (stripeResponse.error) {
        this.error = stripeResponse.error.message;
        this.payButtonDisabled = false;
        return;
      }
      const secondResponse = await this.axios.post(this.postPaymentIntentUrl, {
        payment_intent: stripeResponse.paymentIntent.id,
      });
      window.location = secondResponse.data.location;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: $screen-sm-min) {
    flex-direction: column;
  }
}

.error {
  color: $danger;
  font-weight: $font-weight-bold;
  font-size: $font-size-sm;
}
</style>
